import YogaMultipackTile from './YogaMultipackTile'

export default YogaMultipackTile
// eslint-disable-next-line import/export
export * from './YogaMultipackTile'
